import { render, staticRenderFns } from "./_order.vue?vue&type=template&id=b589cc40"
import script from "./_order.vue?vue&type=script&lang=js"
export * from "./_order.vue?vue&type=script&lang=js"
import style0 from "./_order.vue?vue&type=style&index=0&id=b589cc40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports